// // App.jsx
// import React, { useRef } from "react";
// import Navbar from "./components/Navbar";
// import Landing from "./components/Landing";
// import About from "./components/About";
// // import Products from "./components/Product";
// // import Services from "./components/Services";
// import Footer from "./components/Footer";
// import { colors } from "./Color";
// import Mission from "./components/Mission";
// import ProductAndService from "./components/ProductAndService";
// import ContactUs from "./components/Contact";

// export default function App() {
//   const aboutRef = useRef(null);
//   // const productsRef = useRef(null);
//   // const servicesRef = useRef(null);
//   const contactRef = useRef(null);
//   const missionRef = useRef(null);
//   const ProductAndServiceRfe = useRef(null);

//   const scrollTo = (ref) => ref.current?.scrollIntoView({ behavior: "smooth" });

//   return (
//     <div
//       className="min-h-screen"
//       style={{ backgroundColor: colors.background, color: colors.text }}
//     >
//       <Navbar
//         onNavigate={{
//           about: () => scrollTo(aboutRef),
//           //products: () => scrollTo(productsRef),
//           // services: () => scrollTo(servicesRef),
//           contact: () => scrollTo(contactRef),
//           ProductAndService: () => scrollTo(ProductAndServiceRfe),
//           mission: () => scrollTo(missionRef),
//         }}
//       />
//       <Landing />
//       <div ref={aboutRef}>
//         <About />
//       </div>
//       <div ref={missionRef}>
//         <Mission />
//       </div>
//       <div ref={ProductAndService}>
//         <ProductAndService />
//       </div>
//       {/* <div ref={productsRef}>
//         <Products />
//       </div>
//       <div ref={servicesRef}>
//         <Services />
//       </div> */}
//       <div ref={contactRef}>
//         <ContactUs />
//       </div>
//       <div ref={contactRef}>
//         <Footer />
//       </div>
//     </div>
//   );
// }

import React, { useRef, useState } from "react";
import Sidebar from "./components/Sidebar";
import Landing from "./components/Landing";
import About from "./components/About";
import Footer from "./components/Footer";
import { colors } from "./Color";
import Mission from "./components/Mission";
import ProductAndService from "./components/ProductAndService";
import ContactUs from "./components/Contact";
import HeroSection from "./components/Herosection";
import WhyChooseUs from "./components/WhyChooseUs";

export default function App() {
  const aboutRef = useRef(null);
  const contactRef = useRef(null);
  const missionRef = useRef(null);
  const productAndServiceRef = useRef(null);
  const whychooseusRef = useRef(null);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const scrollTo = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
    setSidebarOpen(false); // Close sidebar after navigation
  };

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const [selectedTab, setSelectedTab] = useState("product");

  const handleScrollAndTabChange = (tab) => {
    setSelectedTab(tab);
    // Scroll smoothly to products section after tab switch
    const el = document.getElementById("products");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div
      className="min-h-screen relative"
      style={{ backgroundColor: colors.background, color: colors.text }}
    >
      <Sidebar
        onNavigateTab={handleScrollAndTabChange}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        toggleSidebar={toggleSidebar}
        onNavigate={{
          about: () => scrollTo(aboutRef),
          contact: () => scrollTo(contactRef),
          mission: () => scrollTo(missionRef),
          ProductAndService: () => scrollTo(productAndServiceRef),
          whychooseus: () => scrollTo(whychooseusRef),
        }}
      />

      <main className="transition-all duration-300">
        <HeroSection />
        <Landing
          onExploreProducts={() => scrollTo(productAndServiceRef)}
          onContactUs={() => scrollTo(contactRef)}
        />
        <div ref={aboutRef}>
          <About />
        </div>
        <div ref={missionRef}>
          <Mission />
        </div>

        <div ref={whychooseusRef}>
          <WhyChooseUs />
        </div>
        <div ref={productAndServiceRef}>
          <ProductAndService
            selectedTab={selectedTab}
            onTabChange={setSelectedTab}
          />
        </div>
        <div ref={contactRef}>
          <ContactUs />
        </div>
        <Footer
          onNavigateTab={handleScrollAndTabChange}
          onContactUs={() => scrollTo(contactRef)}
        />
      </main>
    </div>
  );
}
